import * as React from 'react';

export const FormLabelHelp:
	React.FC<React.PropsWithChildren & { widthtype?: 'normal' | 'wide' }> = ({ widthtype, children }) => {
		widthtype = widthtype || 'wide';
		return <span className={'form__label-help form__label-help--' + widthtype}>{children}</span>;
	};
